import { EventDefinition } from 'redux-beacon'
import { AnyAction } from 'redux'
import { getType } from 'typesafe-actions'
import { FullStackTrackable } from '@chegg/optimizely-sdk'

import { SAAuthType } from '@chegg-wt/core/constants/site'
import { login } from '../user/actions'

export const FREE_TRIAL_START = 'free-trial-start'
export const ACCOUNT_CREATED = 'account-created'
export const CITATION_CREATED = 'citation-created'

const createEvent = (action: AnyAction, eventKey: string): FullStackTrackable => ({
  eventKey,
  eventTags: { action: action.type },
})

export const freeTrialStartEvent: EventDefinition = (action: AnyAction) => {
  return createEvent(action, FREE_TRIAL_START)
}

export const citationCreatedEvent: EventDefinition = (action: AnyAction) => {
  return createEvent(action, CITATION_CREATED)
}

export const accountCreatedEvent: EventDefinition = (action: AnyAction) => {
  const isAccountCreated =
    getType(login) === action.type &&
    action.payload?.saOptions?.auth_type === SAAuthType.SIGN_UP

  return isAccountCreated ? createEvent(action, ACCOUNT_CREATED) : {}
}
